import React from 'react'
import { Input, Label, cn } from "../ui"

function MixtureHeader({ mixture, currentWeight, onNameChange, onMaxWeightUpdate }) {
  const weights = [200, 500]

  return (
    <div className="border-b border-gray-200 p-4">
      <h4 className="text-xl mb-0">Formulation Details</h4>
      <Label className="mt-3 text-gray-500">1. Name your Formula</Label>
      <Input
        value={mixture.name || ''}
        onChange={e => onNameChange(e.target.value)}
        name="name"
        placeholder="e.g. Sleep Tonic"
        className="mb-2"
      />
      <Label className="w-full mt-3 text-gray-500">2. Select your bottle size</Label>
      <div className="inline-flex">
        {weights.map((weight, i) => {
          const active = mixture.max_weight == weight
          return (
            <button
              key={i}
              type="button"
              onClick={() => onMaxWeightUpdate(weight)}
              className={cn(
                "border border-gray-800 px-4 py-2 text-sm font-medium",
                i === 0 && "rounded-l",
                i === weights.length - 1 && "rounded-r",
                i !== 0 && "-ml-px",
                active ? "bg-gray-800 text-white" : "bg-white text-gray-800"
              )}
            >
              {weight}ml
            </button>
          )
        })}
      </div>
      <div className="my-2 flex h-4 w-full overflow-hidden rounded bg-gray-200">
        {mixture.sales_order_items.map(lineItem => (
          <div
            key={lineItem.id}
            title={`${lineItem.name} - ${lineItem.quantity}ml`}
            style={{ width: `${(lineItem.quantity / mixture.max_weight) * 100}%` }}
            className="h-full border-r border-gray-200 bg-integria-green"
          />
        ))}
      </div>
      <p className="text-gray-500">{currentWeight}ml/{mixture.max_weight}ml</p>
      <Label className="text-gray-500">3. Choose your ingredients</Label>
    </div>
  )
}

export default MixtureHeader
